import { useEffect, useState } from 'react'
import { Meta, WappInput, WappMode } from '@weblite-wapps/protocol'
import {
  getPanelHistory,
  getSectionsHistory,
  getSectionsHistoryTop,
  useHistoryCustomBack,
  useNavigate,
} from 'weblite-router'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { VisibilityHandler } from './components/visibility-handler'
import { StaticPanelWappId } from '$logic/wapp-panels'
import { hideCourseVitrine } from '$logic/router'
import { isDesktopSize } from '$func/environmentInfo.js'

export interface CourseVitrineInput {
  isAdmin?: boolean
  channelId?: string
}

export const courseVitrineAPI = {
  setInput(_input: CourseVitrineInput) {},
  setWappMeta(_meta: Meta) {},
}

export function CourseVitrine() {
  const [wappMeta, setWappMeta] = useState<Meta | null>(null)
  const [input, setInput] = useState<CourseVitrineInput>({})

  let isTop: boolean
  if (isDesktopSize()) {
    const activeSections = getSectionsHistory()
    const rightPartTopSection = activeSections.reduce(
      (acc, section) =>
        ['left', 'channelVitrine', 'courseVitrine'].includes(section)
          ? section
          : acc,
      '',
    )

    isTop = rightPartTopSection === 'courseVitrine'
  } else isTop = getSectionsHistoryTop() === 'courseVitrine'

  const [delayedIsTop, setDelayedIsTop] = useState(isTop)

  useEffect(() => {
    if (isTop) {
      setDelayedIsTop(true)
      return
    }

    let timeout: NodeJS.Timer

    // TODO[router]: Refactor
    if (isDesktopSize()) setDelayedIsTop(false)
    timeout = setTimeout(() => setDelayedIsTop(false), 500)

    return () => {
      if (timeout) clearTimeout(timeout)
    }
  }, [isTop])

  useEffect(() => {
    courseVitrineAPI.setInput = setInput
    courseVitrineAPI.setWappMeta = setWappMeta
  }, [])

  const navigate = useNavigate()
  useHistoryCustomBack(
    () => {
      const history = getPanelHistory('courseVitrine')
      const [panelTop] = history.slice(-1)

      if (history.length === 1 || panelTop === 'INIT') hideCourseVitrine()
      else navigate(-1)
    },
    [],
    isTop,
  )

  if (!wappMeta?.wappSessionId || !wappMeta.wappId) return null

  const { channelId } = input
  return (
    <VisibilityHandler zIndex={1} freezeChildren={!delayedIsTop}>
      <div style={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
        <StaticWappPanel
          panelName="courseVitrine"
          wapprunnerKey={`${channelId}-${wappMeta.wappId}`}
          wappId={StaticPanelWappId.COURSE_VITRINE}
          input={input as WappInput}
          mode={WappMode.STATIC}
        />
      </div>
    </VisibilityHandler>
  )
}
